// extracted by mini-css-extract-plugin
export default {"link":"search_media__link--O0Qx","source":"search_media__source--wpk9","title":"search_media__title--lb4d"};